import { Injectable } from "@angular/core";
import { AcuerdosRestService } from "../restAcuerdos.service";

@Injectable({
  providedIn: "root",
})
export class AcuerdosStoreService {
  families: any = [];
  locations: any = [];
  articles: any = [];
  resultBuysQuery: any = [];

  constructor(private acuerdosRest: AcuerdosRestService) {}

  getAllLocations() {
    return new Promise((resolve, reject) => {
      this.acuerdosRest.getAllLocations().subscribe({
        next: (data) => {
          this.locations = data;
          resolve(data);
        },
        error: (err) => {
          reject();
        },
      });
    });
  }

  getFamiliesFromLocations(locationsArray) {
    return new Promise((resolve, reject) => {
      this.acuerdosRest.getFamiliesFromLocation(locationsArray).subscribe({
        next: (data) => {
          this.families = data;
          resolve(data);
        },
        error: (err) => {
          reject();
        },
      });
    });
  }

  getArticlesFromFamilies(familiesArray) {
    return new Promise((resolve, reject) => {
      this.acuerdosRest.getArticlesFromFamilies(familiesArray).subscribe({
        next: (data) => {
          this.articles = data;
          resolve(data);
        },
        error: (err) => {
          reject();
        },
      });
    });
  }

  getBuysSearch(searchQueryData){
    this.acuerdosRest.getBuysSearch(searchQueryData).subscribe({
      next:(data) => {
        if(data)
        this.resultBuysQuery = data;
        
      },
      error:(err) => {   
        this.resultBuysQuery = [];
                
      }
    })
  }
}
